<template>
  <ModalBase :show-modal="showModal" @close-modal="close" short auto-h class="gk-modal-confirm">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal title-modal--simple">
        <template v-slot:title>
          {{ title }}
        </template>
      </TitleBar>
    </template>

    <template v-slot:maincontent>
      <div v-if="options && options.item" class="target-item">
        {{ options.item }}
      </div>
      <div v-html="message" />
      <div v-if="options && options.warning" class="gk-tip gk-tip--warning gk-tip--caution my-4" :style="tipCssVars">
        {{ options.warning }}
      </div>
      <div v-if="options && options.safeguard">
        <b-form-checkbox
          id="checkbox-safeguard"
          v-model="safeguarded"
          name="checkbox-safeguard"
        >
          {{ options.safeguardText }}
        </b-form-checkbox>
      </div>
    </template>

    <template v-slot:actions>
      <GekkoButton
        @click="close()"
        :text="$gettext('Cancel')"
        variant="light"
      />
      <GekkoButton
        @click="confirm()"
        :disabled="(options && options.safeguard && !safeguarded)"
        :text="confirmText"
        :variant="variant"
      />
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";

export default {
  name: 'ConfirmModal',
  components: { ModalBase, TitleBar, GekkoButton },
  props: {
    title: {
      type: String,
      default: 'title default value'
    },
    message: {
      type: String,
      default: 'body default value'
    },
    options: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      showModal: true,
      selectedChoice: null,
      confirmationWarning: false,
      safeguarded: false
    }
  },
  computed: {
    confirmText () {
      return (this.options && this.options.confirmText) ? this.options.confirmText : this.$gettext('Confirm') 
    },
    variant () {
      return (this.options && this.options.variant) ? this.options.variant : 'primary'
    },
    tipCssVars () {
      let cssVars = ''
      cssVars += `--cautiontext: '${ this.$gettext('Caution') }'`
      return cssVars
    }
  },
  methods: {
    close () {
      this.$emit('cancel');
      this.showModal = false
    },
    confirm () {
      this.$emit('confirmed', false)
    }
  }
}
</script>

<style lang="scss">
.gk-modal-confirm {
  position: absolute;
  z-index: 9001;
  .gk-modal {
    max-width: 530px !important;
    padding: 1rem;
    @media (min-width: 768px) {
      padding: 1.5rem;
    }
    .titlebar.title-modal { margin-bottom: 0; }
    .modal-content-wrap {
      padding: 0.5rem 0;
      font-size: 1rem;

      .target-item {
        padding: 1rem;
        margin-bottom: 1rem;
        border-radius: $radiusLg;
        background: $colorBorderDash;
      }
    }
    .action-buttons-wrapper {
      display: flex;
      gap: 0.75rem;
      justify-content: flex-end;
    }
  }
}
</style>